import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);

if (!isSupabaseConfigured) {
  // Fail loud in dev so missing .env.local is obvious, but don't crash the app
  // (createClient throws on empty url/key, so we fall back to inert placeholders).
  console.error(
    "[supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. " +
      "Copy .env.example to .env.local and fill in the RE CINE values."
  );
}

export const supabase = createClient<Database>(
  SUPABASE_URL || "http://placeholder.invalid",
  SUPABASE_ANON_KEY || "placeholder-anon-key"
);
